import './ToggleButton.scss'

export const DsrPreviewToggleButton = ({offLabelText, onLabelText, isChecked, setIsChecked, isLockedRoom}) => {
  const handleChange = () => {
    setIsChecked(prevState => !prevState);
  };

  if (isLockedRoom) {
    return null
  } else {
    return (
      <>
        <input
          type="checkbox"
          id="toggle"
          checked={isChecked}
          onChange={handleChange}
          className="toggleCheckbox"
        />
        <label htmlFor="toggle" className='toggleContainer'>
          <div>{offLabelText ? offLabelText : 'Off'}</div>
          <div>{onLabelText ? onLabelText : 'On'}</div>
        </label>
      </>
    )
  }
  
}
